import { Link } from "react-router-dom";
import { Separator } from "@/src/components/ui/separator";
import { Button } from "@/src/components/ui/button";
import { ExternalLink } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-muted/30 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <img
              src="/logo.png"
              alt="Iwantcoaching Logo"
              className="h-14 w-auto object-contain mb-6"
            />
            <p className="text-muted-foreground max-w-sm leading-relaxed mb-4">
              Empowering individuals to discover their true strengths and lead a life of purpose through professional coaching and talent discovery.
            </p>
            <p className="text-muted-foreground text-sm mb-8">
              184 Koelman Rd, Ashlea Gardens,<br />
              Pretoria, 0081, South Africa
            </p>
            
            <div className="flex flex-wrap gap-4">
              <Button variant="outline" size="sm" className="rounded-full border-primary/20 hover:border-primary text-xs" asChild>
                <a href="https://positivepsychologynews.com/" target="_blank" rel="noopener noreferrer">
                  Positive Psychology News <ExternalLink className="ml-2 w-3 h-3" />
                </a>
              </Button>
              <Button variant="outline" size="sm" className="rounded-full border-primary/20 hover:border-primary text-xs" asChild>
                <a href="https://www.gallup.com/cliftonstrengths/en/home.aspx" target="_blank" rel="noopener noreferrer">
                  Gallup CliftonStrengths <ExternalLink className="ml-2 w-3 h-3" />
                </a>
              </Button>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/#about" className="hover:text-primary transition-colors">About</Link></li>
              <li><Link to="/workshops" className="hover:text-primary transition-colors">Workshops</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/#testimonials" className="hover:text-primary transition-colors">Testimonials</Link></li>
              <li><Link to="/#services" className="hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/#contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-6">Legal</h4>
            <ul className="space-y-4 text-muted-foreground">
              <li><Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <Separator className="bg-primary/10 mb-8" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Iwantcoaching. All rights reserved. - Created by <a href="https://chemcoolweb.co.za" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors font-medium">Chemcoolweb</a></p>
          <div className="flex items-center gap-6">
            <a href="mailto:johan@iwantcoaching.co.za" className="hover:text-primary transition-colors font-medium">johan@iwantcoaching.co.za</a>
            <a href="https://www.linkedin.com/in/johan-oosthuizen-a625731b4/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
